<template>
        <a-modal :title="$t('asnPage.UploadPhoto')+' - '+this.asnNo" v-model="visible" width="50%">
            <div class="clearfix">
                <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
                    <a-button> <a-icon type="upload" /> Select File </a-button>
                </a-upload>
                <a-button
                        type="primary"
                        :disabled="fileList.length === 0"
                        :loading="uploading"
                        style="margin-top: 16px"
                        @click="handleUpload"
                >
                    {{ uploading ? 'Uploading' : 'Start Upload' }}
                </a-button>
            </div>
            <template slot="footer">
                <a-button @click="() => (visible = !visible)" size="small" type="primary">{{ $t('publicLang.Close') }}</a-button>
            </template>
        </a-modal>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import axios from "axios";
    import store from "../../../store";
    import cookie from "../../../api/cookie";
    export default{
        data(){
            return{
                visible: false,
                fileList: [],
                uploading: false,
                asnUid: "",
                asnNo: '',
            }
        },
        methods:{
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
            },
            beforeUpload(file) {
                this.fileList = [...this.fileList, file];
                return false;
            },
            handleUpload() {
                const { fileList } = this;
                const formData = new FormData();
                fileList.forEach(file => {
                    formData.append('file', file);
                });
                formData.append("asnNo", this.asnNo);
                this.uploading = true;
                axios({
                    url: 'https://cargo-ecwms-dev.azure-api.net/inbound/uploadFile',
                    method: 'post',
                    processData: false,
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    data: formData,
                    success: () => {
                        this.fileList = [];
                        this.uploading = false;
                        this.$message.success('upload successfully.');
                    },
                    error: () => {
                        this.uploading = false;
                        this.$customMessage.error('upload failed.');
                    },
                });
            },
            show(param){
                this.visible = true
                let params = {}
                this.asnUid = param.uidList;
                params.asnUid = param.uidList;
                this.getAsnNoByUid(params);
            },
            getAsnNoByUid(params){//根据Uid查询ASN号码
                ajax.get(api.SCANINIDGET,params).then(res=>{
                    this.asnNo = res.data.recId
                })
            }
        }
    }
</script>